<template>
  <ErrorModal />
  <q-dialog v-model="show" persistent class="save-scheme-main">
    <q-card
      style="min-width: 350px"
      class="save-dialog welcome-dialog-onboarding"
    >
      <q-card-section>
        <div style="color: #0a108f" class="text-main bold-font">
          {{ t("welcome_dialog.message") }}
        </div>
      </q-card-section>

      <q-separator />

      <q-card-section class="q-pt-none q-pa-md">
        <div class="row justify-around">
          {{ t("welcome_dialog.notification") }}
        </div>
      </q-card-section>

      <q-separator />

      <q-card-actions class="bold-font q-ml-sm" align="center">
        <q-btn
          color="white"
          class="orange-btn-filled"
          flat
          :label="t('common.ok')"
          style="width: 90px"
          no-caps
          @click="disableModal()"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import store from "../../store/index";
import UserService from "../../services/userprofile.service";
import { useI18n } from "vue-i18n";

export default {
  setup() {
    const { locale } = useI18n();
    const langCode = computed({
      get: () => store.state.user.customerLanguageCodeForUser,
    });

    onMounted(async () => {
      UserService.getFavoriteAudienceTags(locale);
      UserService.getFavoritePurposesTags(locale);
      UserService.getFavoriteLocationsTags(locale);

      await UserService.getCustomerLanguageCodeForUser(authUser.value.id);
      if (langCode.value == "de") {
        await UserService.completeOnboarding(authUser.value.id);
      }
    });

    const show = ref(true);

    const disableModal = async () => {
      if (
        (favoriteAudience.value && favoriteAudience.value.length > 0) ||
        (favoritePurposes.value && favoritePurposes.value.length > 0) ||
        (selectedFavoriteLocations.value &&
          selectedFavoriteLocations.value.length > 0)
      ) {
        await UserService.completeOnboarding(authUser.value.id);

        store.commit("user/updateHasBeenRedirectedToProfile", false);
        show.value = false;
      }

      store.commit("user/updateHasBeenRedirectedToProfile", false);
      show.value = false;
    };

    const favoriteAudience = computed({
      get: () => store.state.user.favoriteAudiencesIdsArray,
    });

    const favoritePurposes = computed({
      get: () => store.state.user.favoritePurposesIdsArray,
    });

    const selectedFavoriteLocations = computed({
      get: () => store.state.user.selectedFavoriteLocations,
    });
    const authUser = computed(() => store.state.auth.authUser);

    return {
      locale,
      authUser,
      favoriteAudience,
      favoritePurposes,
      selectedFavoriteLocations,
      disableModal,
      show,
    };
  },
};
</script>
